export const GET_PLV_WATCH_LINK_SUCCESS = 'GET_PLV_WATCH_LINK_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_ERROR = 'SET_ERROR';
export const LOADING_MESSAGE = '请稍等...';
